/**
 * v48 (SH-3): унифицированное форматирование контактной строки юзера для AML/Scoring.
 *
 * Backend хранит user_name/user_email/user_phone пустыми если KYC ещё не закрыт
 * (v47 AML UI fix). Раньше каждый компонент сам делал `name || phone || '—'` по-своему,
 * что приводило к рассинхрону между списком и карточкой.
 */

export interface UserSummary {
  userName?: string;
  userEmail?: string;
  userPhone?: string;
  userId?: string;
}

/** Имя для primary-строки: name → phone → '—'. */
export function primaryName(u: UserSummary): string {
  return u.userName || u.userPhone || '—';
}

/** Контакт для secondary-строки: email если есть, иначе phone (если не использован уже как имя), иначе пусто. */
export function secondaryContact(u: UserSummary): string {
  if (u.userEmail) return u.userEmail;
  if (u.userName && u.userPhone) return u.userPhone;
  return '';
}

/** Inline-строка через ` · `: «Имя · Email · Phone». Пустые поля выбрасываются. */
export function userSummaryInline(u: UserSummary): string {
  const parts = [u.userName, u.userEmail, u.userPhone].filter(Boolean) as string[];
  return parts.length > 0 ? parts.join(' · ') : '—';
}
